<template>
    <v-dialog persistent v-model="get_dialogMain.dialog" :width="get_dialogMain.withWindows" justify-center>
      <v-card width="auto" tile>
          <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title><h3>{{get_dialogMain.title}}</h3></v-toolbar-title>
                <v-spacer/>
            <v-btn icon dark @click="HIDDE_DIALOG_MAIN"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pa-2">
            <MainProcessForm v-if="get_dialogMain.form === 'form'" :model="nomina" :form="form" :on-success="saveNomina" :on-cancel="cancel"/>
            <NominaDetailConceptsForm v-if="get_dialogMain.form === 'NominaDetalleConceptos'" :model="view" :on-cancel="cancel"/>
            <ImportDataForm v-if="get_dialogMain.form === 'importData'" :model="nomina" :itemAction="form" :on-success="saveNomina" :on-cancel="cancel"/>
          <v-alert type="error" v-if="show">
            <p class="font-weight-bold">{{ error.message }}</p>
            <v-virtual-scroll v-if="error.list" :items="error.list" :item-height="35" height="300">
              <template v-slot="{ item }">
                <v-list-item :key="item" :value="item">
                  <v-list-item-content>
                    <v-list-item-title v-text="item" />
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-virtual-scroll>
          </v-alert>
          </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import MainProcessForm from '@/components/forms/main/MainProcessForm'
import ImportDataForm from '@/components/forms/main/ImportDataForm'

import NominaDetailConceptsForm from '@/components/forms/nomina/NominaDetailConceptsForm'

export default {
  props: ['model', 'params'],
  data: () => ({
    form: {
      status_start: {
        formulario: {
          fields: []
        }
      },
      status_finish: {
        formulario: {
          fields: []
        },
        estatus: ''
      }
    },
    nomina: {},
    show: false,
    error: {
      list: null,
      message: null
    }
  }),
  components: {
    MainProcessForm,
    ImportDataForm,
    NominaDetailConceptsForm
  },
  mounted () {
    if (this.model.action) {
      this.form = this.model.body
    } else {
      this.nomina = this.model
      this.getFormServices('GET/nomina/adscripcion/options/{procss}[/{id}]')
    }
  },
  methods: {
    ...mapActions(['GetFormOptionServicesAction', 'postExecuteAction']),
    saveNomina (model) {
      if (this.get_dialogMain.type !== 'create') {
        model.id = this.model.item.id
      }
      if (this.params.update) {
        model.action = 'toEditAdscripcion'
      }
      const router = this.get_urls['POST/nomina/adscripcion/execute']
      this.postExecuteAction({ url: router, data: model })
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    // * ========== * ========== * ========== * ========== * ========== *
    getFormServices (url) {
      const router = this.get_urls[url]
      this.GetFormOptionServicesAction({ url: router, data: {}, params: '/3' })
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'SET_DATA', 'SET_RELOAD_DATA', 'CLEAR_DATA'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_options', 'get_model'])
  },
  watch: {
    get_options (val) {
      if (val) {
        this.form = val
      }
    },
    get_model (val) {
      if (val.message) {
        if (val.list) {
          this.error = val
          this.show = true
          return
        }
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }

      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Registro agregado correctamente'
      })
      if (this.params.reload) {
        this.SET_RELOAD_DATA(val)
        this.cancel()
        return
      }
      this.SET_DATA(val)
      this.cancel()
    }
  }
}
</script>

<style>

</style>
